let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cdbJ8")).then(() => parcelRequire('hL1wh'));